<app-dialog
  headerGlyph="trash"
  [headerText]="title"
  saveText="Delete"
  [showTopCancelButton]="false"
  [body]="body"
  (save)="onDelete()"
  [validationFn]="validate.bind(this)"
>
  <ng-template #body>
    @if (!loading) {
      <div class="container">
        <div>{{ msg }}</div>
        <app-constraint-notification
          [resource]="resource"
          type="delete"
        ></app-constraint-notification>
        @if (!!errorMsg) {
          <app-error-strip
            [errorText]="FAILED_MSGS[resource.type] || 'Cannot delete resource'"
            [errorMsg]="errorMsg"
          ></app-error-strip>
        }
      </div>
    }
  </ng-template>
</app-dialog>
